<template>
  <el-form label-position="top" class="register-form" style="max-width: 480px;">
    <el-form-item label="*手机号" prop="mobile">
      <el-input v-model="form.mobile" autocomplete="new-password" size="small" placeholder="客户登录手机号"></el-input>
    </el-form-item>
    <el-form-item label="*密码" prop="password">
      <el-input v-model="form.password" autocomplete="new-password" type="password" size="small" placeholder="登录密码"></el-input>
    </el-form-item>
    <el-form-item label="*名称" prop="passportName">
      <el-input v-model="form.passportName" autocomplete="new-password" size="small" placeholder="客户名称"></el-input>
    </el-form-item>
    <el-form-item label="*公司" prop="companyName">
      <el-input v-model="form.companyName" autocomplete="new-password" size="small" placeholder="客户公司名称"></el-input>
    </el-form-item>
    <el-form-item label="*地址" prop="addressDetail">
      <div class="area-select">
        <el-select v-model="form.province" placeholder="省" size="small">
          <el-option v-for="p in provinces" :key="p.code" :label="p.name" :value="p.name" />
        </el-select>
        <el-select v-model="form.city" placeholder="市" :disabled="!form.province" size="small">
          <el-option v-for="c in citys" :key="c.code" :label="c.name" :value="c.name" />
        </el-select>
        <el-select v-model="form.area" placeholder="区" :disabled="!form.province || !form.city" size="small">
          <el-option v-for="a in areas" :key="a.code" :label="a.name" :value="a.name" />
        </el-select>
      </div>
      <el-input v-model="form.addressDetail" placeholder="详细地址" size="small" />
    </el-form-item>
    <el-form-item label="税号" prop="taxCode">
      <el-input v-model="form.taxCode" autocomplete="new-password" size="small" placeholder="客户公司税号"></el-input>
    </el-form-item>
    <el-form-item label="营业执照" class="license-upload">
      <zpc-uploader v-model="form.license" :limit="1" />
    </el-form-item>
    <el-form-item label="门头照片" class="picture-upload">
      <zpc-uploader v-model="form.pictures" :limit="3" />
    </el-form-item>
    <el-button type="primary" size="small" @click="doSubmit">确定</el-button>
  </el-form>
</template>
<script>
import ZpcUploader from '@/components/ZpcUploader.vue'
import { register } from '../services.js'
import _ from 'lodash'
export default {
  name: 'RegisterForm',
  components: { ZpcUploader },
  data () {
    return {
      form: {
        password: undefined,
        mobile: undefined,
        passportName: undefined,
        companyName: undefined,
        taxCode: undefined,
        province: undefined,
        city: undefined,
        area: undefined,
        addressDetail: undefined,
        license: [],
        pictures: []
      }
    }
  },
  computed: {
    allAreas () {
      return this.$store.state.areas || []
    },
    provinces () {
      return this.allAreas.map(t => ({ code: t.code, name: t.name }))
    },
    citys () {
      if (this.form.province) {
        const prov = this.allAreas.find(t => t.name === this.form.province)
        return prov.children.map(t => ({ code: t.code, name: t.name }))
      } else {
        return []
      }
    },
    areas () {
      if (this.form.city) {
        const prov = this.allAreas.find(t => t.name === this.form.province)
        const city = prov.children.find(t => t.name === this.form.city)
        return city.children.map(t => ({ code: t.code, name: t.name }))
      } else {
        return []
      }
    }
  },
  watch: {
    'form.province' (val) {
      this.form.city = undefined
    },
    'form.city' (val) {
      this.form.area = undefined
    }
  },
  beforeMount () {
    if (!this.allAreas || !this.allAreas.length) {
      this.$store.dispatch('loadAreas')
    }
    this.doResgister = _.debounce(() => {
      register(this.form).then(() => {
        this.$router.push('/customer')
      })
    }, 1000, {
      leading: true,
      trailing: false
    })
  },
  methods: {
    checkModel () {
      return new Promise((resolve, reject) => {
        const regExp = new RegExp('^1[3-9]{1}[0-9]{9}$')
        const { mobile, password, passportName, companyName, province, city, area, addressDetail } = this.form
        if (!regExp.test(mobile)) {
          reject(new Error('请输入正确的手机号'))
        }
        if (!password || password.length < 6) {
          reject(new Error('请输入至少6位密码'))
        }
        if (!passportName || !passportName.trim()) {
          reject(new Error('请输入非空用户名'))
        }
        if (!companyName || !companyName.trim()) {
          reject(new Error('请输入非空公司名称'))
        }
        if (!province || !city || !area || !addressDetail) {
          reject(new Error('请输入完整地址'))
        }
        resolve(true)
      })
    },
    doSubmit () {
      this.checkModel()
        .then(() => {
          this.doResgister()
        }).catch((err) => {
          this.$message.error(err.message)
        })
    }
  }
}
</script>
